import { render } from "./IssuePopUp.vue?vue&type=template&id=f4f7bc10&scoped=true"
import script from "./IssuePopUp.vue?vue&type=script&lang=js"
export * from "./IssuePopUp.vue?vue&type=script&lang=js"

import "./IssuePopUp.vue?vue&type=style&index=0&id=f4f7bc10&lang=css"
import "./IssuePopUp.vue?vue&type=style&index=1&id=f4f7bc10&scoped=true&lang=css"

import exportComponent from "/home/nils/assessment_tool/code/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4f7bc10"]])

export default __exports__